import React from "react";
//#region types
import { DrillDownTableChildrenRowsProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import DrillDownTableRow from "./row";
import cssExports from "theme/styles/main.module.scss";
//#endregion
import clsx from "clsx";

const DrillDownTableRowDimensionChildren: React.FC<DrillDownTableChildrenRowsProps> = (props) => {
  const { rows, depth, parentIndex, path } = props;

  return (
    <>
      {rows.map((row, childRowIndex) => (
        <DrillDownTableRow
          {...props}
          key={`tab-row-dimension-${depth + 1}-${childRowIndex}`}
          row={row}
          index={childRowIndex}
          parentIndex={parentIndex}
          path={[...path, parentIndex]}
          depth={depth}
          className={clsx(childRowIndex === rows.length - 1 ? cssExports.lastRowOfChildren : "", props.className)}
        />
      ))}
    </>
  );
};

export default DrillDownTableRowDimensionChildren;
